export enum ModulosBloqueables {
    // FACTURACION MASIVA
    RECEPCION_PEDIDOS = 32,
    ANALISIS_DEMANDA = 33,
    CONFIRMACION_NOTA_VENTA = 34,
    ASIGNACION_RUTEADOR = 35,
    ASIGNACION_MANUAL = 137,
    // VENTAS
    FACTURACION_MANUAL = 26,
    NOTA_DE_VENTA = 27,
    NOTA_DE_CREDITO = 28,
    NOTA_DE_DEBITO = 29,
    GUIA_DE_DESPACHO = 30,
    // RECORRIDOS
    DEVOLUCION_MERCADERIA = 39,
    LIQUIDACION_RECORRIDO = 40,
    MERCADERIA_DEVUELTA = 135,
    CONSULTA_RECORRIDO = 136,
    // REPORTES
    // R_STOCK_PRODUCTO = 52,
    // R_MOVIMIENTO_STOCK = 53,
    // R_STOCK_VALORIZADO = 54,
    // R_MOVIMIENTO_SKU = 56,
    // R_VENTAS_CANAL = 119,
    // R_VENTAS_ESPECIFICAS = 120,
    // R_VENTAS_PRODUCTO = 121,
    // R_VENDEDORES = 122,
    // R_VENDEDORES_CLIENTES = 123,
    // R_TERRITORIOS = 124,
    // R_TERRITORIOS_ANUALIZADO = 125,
    // R_PRODUCTO_GENERAL = 126,
    // R_PRODUCTO_ANUALIZADO = 127,
    // R_VENTAS_GENERAL = 128,
    // R_LIBRO_VENTA = 132,
    // R_LIBRO_COMPRA = 133,
    // R_NOTA_CREDITO = 139,
    // R_VENDEDORES_FAMILIA = 141,
    // R_COBERTURA_IPT = 142,
    // R_CHECK_IN_OUT = 145,
}
